import { GridColDef } from '@microservices/wiskey-react-table-component'
import { MobileMap } from '@mobileTypes'

export const MOBILE_MAPS_COLUMNS: GridColDef[] = [
  {
    field: 'internalId',
    headerName: 'Internal ID',
    flex: 1,
    minWidth: 120,
  },
  {
    field: 'name',
    headerName: 'Name',
    flex: 1,
    minWidth: 200,
  },
]

export const DEFAULT_MOBILE_MAP: Omit<MobileMap, 'id' | 'createdAt' | 'updatedAt'> = {
  internalId: '',
  name: '',
  mapCenter: [37.6, 55.75],
  mapZoom: 12,
  mapStyleUrl: '',
  showCurrentLocation: false,
  mapPointGroups: [],
  variables: [],
  eventFlows: [],
}
